import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import Form from "react-bootstrap/Form";
import {
  FaUserGraduate,
  FaIdCard,
  FaMapMarkerAlt,
  FaUserFriends,
  FaPhoneAlt,
  FaCheckCircle,
  FaCamera,
  FaCalendarAlt,
  FaExchangeAlt,
  FaSchool,
  FaBus,
  FaCheck,
} from "react-icons/fa";
import SessionManager from "../Utils/SessionManager";
import MyLoader from "../Spinner/MyLoader";
import myToast from "../Utils/MyToast";
import BackButton from "../ChildComponent/BackButton";
import COLORS from "../resources/colors/COLORS";
import MdlSelectSession from "../dialog/MdlSelectSession";
import { MOTHER_TONGUE_OPTIONS } from "./MotherTongue";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/payroll.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const HERO_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

const PAGE_FONT =
  'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

const RELIGIONS = [
  "Hindu",
  "Muslim",
  "Christian",
  "Sikh",
  "Buddhist",
  "Jain",
  "Other",
];

const GENDERS = ["Male", "Female"];
const COMMUNITIES = ["SC", "ST", "OBC", "General", "Others"];
const BLOOD_GROUPS = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-", "Unknown"];
const YES_NO = ["Yes", "No"];
const TRANSPORT_SERVICE_ID = "SRV001";
const ADMISSION_TYPES = [
  { value: "New", label: "New Admission" },
  { value: "Re", label: "Re-Admission" },
];

const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const MONTH_NAME_TO_NUMBER = {
  Jan: "01",
  Feb: "02",
  Mar: "03",
  Apr: "04",
  May: "05",
  Jun: "06",
  Jul: "07",
  Aug: "08",
  Sep: "09",
  Oct: "10",
  Nov: "11",
  Dec: "12",
};
const HOURS_12 = Array.from({ length: 12 }, (_, i) => String(i + 1));
const MINUTES_60 = Array.from({ length: 60 }, (_, i) =>
  String(i).padStart(2, "0")
);

const EMPTY_TRANSPORT = {
  routeId: "",
  vehicleId: "",
  pickupPoint: "",
  pickupPointId: "",
  pickupHour: "",
  pickupMinute: "",
  pickupAmPm: "AM",
  transportFee: "",
};

const RELATIONS = [
  "Father",
  "Mother",
  "Uncle",
  "Aunt",
  "Grand Father",
  "Grand Mother",
  "Elder Brother",
  "Younger Brother",
  "Elder Sister",
  "Younger Sister",
  "Maternal Uncle",
  "Maternal Aunt",
  "Maternal Grand Father",
  "Maternal Grand Mother",
];

const EMPTY_FORM = {
  AddmisType: "New",
  AddmissionNumber: "1",
  FirstName: "",
  LastName: "",
  dob: "",
  date: "",
  gender: "",
  caste: "",
  community: "",
  RELIGION: "",
  AdharNo: "",
  nationality: "Indian",
  bloodgroup: "",
  mother_tongue: "",
  birth_place: "",
  height: "",
  weight: "",
  student_pen: "",
  student_apaar: "",
  bpl_beneficiary: "No",
  physical_disability: "No",
  board_id: "",
  medium_id: "",
  curAddress: "",
  perAddress: "",
  FatherName: "",
  fatherOccupation: "Farmer",
  father_qualification: "",
  father_aadhar: "",
      motherName: "",
  motherOccupation: "House Wife",
      mother_qualification: "",
      mother_aadhar: "",
  contact1: "",
  contactName_1: "",
  relation_1: "",
  contact2: "",
  contactName_2: "",
  relation_2: "",
  email: "",
  previous_school_name: "",
  previous_class: "",
  StateSpecificIdName: "",
  StateSpecificIdValue: "",
};

//Created By Cursor
function parseSessionStartDate(raw) {
  if (!raw) return null;
  const value = String(raw).trim();
  let m = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
  m = value.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
  if (m) return new Date(+m[3], +m[2] - 1, +m[1]);
  const fallback = new Date(value);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
}

//Created By Cursor
function defaultAcademicStart() {
  const now = new Date();
  const year = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
  return new Date(year, 3, 1);
}

//Created By Cursor
function resolveSessionStartDate(preferred) {
  const candidates = [
    preferred,
    typeof localStorage !== "undefined" ? localStorage.getItem("START_DATE") : null,
    SessionManager.getCurrentSession()?.[0]?.start_date,
  ];
  for (let i = 0; i < candidates.length; i++) {
    const parsed = parseSessionStartDate(candidates[i]);
    if (parsed) return parsed;
  }
  return defaultAcademicStart();
}

//Created By Cursor
function buildSessionMonths(preferred) {
  const cal = resolveSessionStartDate(preferred);
  const y0 = cal.getFullYear();
  const m0 = cal.getMonth();
  const months = new Array(12);
  for (let i = 0; i < 12; i++) {
    const d = new Date(y0, m0 + i, 1);
    months[i] = `${MONTH_NAMES[d.getMonth()]} ${d.getFullYear()}`;
  }
  return months;
}

//Created By Cursor
function reverseApplicableMonths(monthList) {
  if (!monthList?.length) return "";
  const out = [];
  for (let i = 0; i < monthList.length; i++) {
    const [monthName, year] = String(monthList[i]).split(" ");
    const month = MONTH_NAME_TO_NUMBER[monthName];
    if (month && year) out.push(`${year}-${month}`);
  }
  return out.join(",");
}

//Created By Cursor
function toApiPickupTime(hour12, minute, ampm) {
  if (!hour12 || minute === "" || minute == null || !ampm) return "";
  let h = parseInt(hour12, 10);
  if (Number.isNaN(h) || h < 1 || h > 12) return "";
  const m = String(minute).padStart(2, "0");
  if (ampm === "AM") {
    if (h === 12) h = 0;
  } else if (ampm === "PM") {
    if (h !== 12) h += 12;
  } else {
    return "";
  }
  return `${h}:${m}`;
}

//Created By Cursor
function Field({ label, required, optional, children, hint, className = "" }) {
  return (
    <div className={`sr-field${className ? ` ${className}` : ""}`}>
      <label className="sr-field__label">
        {label}
        {required ? <span className="sr-field__req">*</span> : null}
        {optional ? <span className="sr-field__opt">Optional</span> : null}
      </label>
      {children}
      {hint ? <span className="sr-field__hint">{hint}</span> : null}
    </div>
  );
}

//Created By Cursor
function SectionCard({ icon: Icon, title, subtitle, step, children, extra }) {
  return (
    <section className="sr-section stur-section stur-section--compact">
      <div className="sr-section__head stur-section__head">
        <span className="stur-section__step" aria-hidden>
          {step || <Icon />}
        </span>
        <div className="min-w-0">
          <h2 className="sr-section__title">{title}</h2>
          {subtitle ? <p className="sr-section__sub">{subtitle}</p> : null}
        </div>
        {extra ? <div className="sr-section__extra">{extra}</div> : null}
      </div>
      <div className="sr-section__body">{children}</div>
    </section>
  );
}

//Created By Cursor
function classChipLabel(item) {
  if (!item) return "Class";
  if (item.section_id === "No" || !item.section_name) {
    return item.class_name || "Class";
  }
  return `${item.class_name}: ${item.section_name}`;
}

//Created By Cursor
function buildFilteredClassSections(classData, boardId, mediumId) {
  if (!boardId || !mediumId || !Array.isArray(classData)) return [];

  const matched = classData.filter(
    (item) =>
      String(item.board_id) === String(boardId) &&
      String(item.medium_id) === String(mediumId)
  );

  const flat = [];
  matched.forEach((item) => {
    if (item.section === "No") {
      flat.push({
        ...item,
        section_id: "No",
      });
      return;
    }

    const sections = Array.isArray(item.section) ? item.section : [];
    sections.forEach((sectionItem) => {
      flat.push({
        ...sectionItem,
        board_id: boardId,
        board_name: item.board_name,
        medium_id: mediumId,
        medium_name: item.medium_name,
      });
    });
  });

  return flat;
}

//Created By Cursor
function nextAdmissionNo(raw) {
  if (!raw) return "1";
  const parts = String(raw).match(/[a-z]+|[^a-z]+/gi);
  if (!parts || parts.length === 0) return "1";
  if (parts.length === 1) return String(parseInt(parts[0], 10) + 1);
  if (isFinite(parts[0])) {
    return String(parseInt(parts[0], 10) + 1) + parts[1];
  }
  return parts[0] + String(parseInt(parts[1], 10) + 1);
}

const StudentRegistration = () => {
  const loggedIn = localStorage.getItem("token") != null;

  const currentSession = SessionManager.getCurrentSession()?.[0] || {};

  const [formData, setFormData] = useState(EMPTY_FORM);
  const [sameAsCurrent, setSameAsCurrent] = useState(false);

  const [SESSION_ID, setSessionId] = useState(currentSession.session_id || "");
  const [SESSION_NAME, setSessionName] = useState(
    currentSession.session_name || ""
  );
  const [SESSION_STATUS, setSessionStatus] = useState(
    currentSession.status || ""
  );

  const [classBoard, setClassBoard] = useState([]);
  const [classMedium, setClassMedium] = useState([]);
  const [mClassData, setMClassData] = useState([]);
  const [classList, setClassList] = useState([]);
  const [classSelectedPosition, setClassSelectedPosition] = useState(0);
  const [CLASS_ID, setClassId] = useState("");
  const [SECTION_ID, setSectionId] = useState("");

  const [bootLoading, setBootLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [isOpenSessionDialog, setIsOpenSessionDialog] = useState(false);
  const [photoPreview, setPhotoPreview] = useState(null);
  const photoInputRef = useRef(null);
  const transportAbortRef = useRef(null);

  const [transportGranted, setTransportGranted] = useState("No");
  const [transportForm, setTransportForm] = useState(EMPTY_TRANSPORT);
  const [serviceMonth, setServiceMonth] = useState([]);
  const [sessionMonths, setSessionMonths] = useState(() =>
    buildSessionMonths(currentSession.start_date)
  );
  const [sessionStartDate, setSessionStartDate] = useState(
    currentSession.start_date || ""
  );
  const [routesList, setRoutesList] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [pickupPoints, setPickupPoints] = useState([]);
  const [transportLoading, setTransportLoading] = useState(false);

  //Created By Cursor
  const pickupByName = useMemo(() => {
    const map = new Map();
    for (let i = 0; i < pickupPoints.length; i++) {
      const point = pickupPoints[i];
      const name = String(point.pickup_point_name || "")
        .trim()
        .toLowerCase();
      if (name) map.set(name, point.pickup_point_id || "");
    }
    return map;
  }, [pickupPoints]);

  const pickupTime = useMemo(
    () =>
      toApiPickupTime(
        transportForm.pickupHour,
        transportForm.pickupMinute,
        transportForm.pickupAmPm
      ),
    [
      transportForm.pickupHour,
      transportForm.pickupMinute,
      transportForm.pickupAmPm,
    ]
  );

  const selectedMonthSet = useMemo(() => new Set(serviceMonth), [serviceMonth]);
  const allMonthsSelected =
    sessionMonths.length > 0 && serviceMonth.length === sessionMonths.length;

  //Created By Cursor
  const getTransportSetupData = useCallback(async () => {
    if (transportAbortRef.current) transportAbortRef.current.abort();
    const controller = new AbortController();
    transportAbortRef.current = controller;

    const schoolCode = SessionManager.getSchoolCode();
    if (!schoolCode) {
      myToast.notify_warning("School code is missing.");
      return;
    }

    setTransportLoading(true);
    try {
      const response = await axios.get(`${API_BASE()}getTransportSetupData.php`, {
        params: { school_code: schoolCode },
        signal: controller.signal,
      });
      if (controller.signal.aborted) return;

      if (response.data?.api_status === "OK") {
        const data = response.data.data || {};
        setRoutesList(data.routes || []);
        setPickupPoints(data.PickupPoints || []);
        setVehicleList(data.VehicleList || []);
      } else {
        setRoutesList([]);
        setPickupPoints([]);
        setVehicleList([]);
        myToast.notify_warning(
          response.data?.api_remark || "Could not load transport setup."
        );
      }
    } catch (error) {
      if (
        axios.isCancel?.(error) ||
        error?.name === "CanceledError" ||
        error?.code === "ERR_CANCELED"
      ) {
        return;
      }
      console.error(error);
      myToast.notify_warning("Network error loading transport setup.");
    } finally {
      if (!controller.signal.aborted) setTransportLoading(false);
    }
  }, []);

  //Created By Cursor
  const handleTransportGranted = useCallback(
    (value) => {
      setTransportGranted(value);
      if (value === "Yes") {
        setSessionMonths(buildSessionMonths(sessionStartDate));
        getTransportSetupData();
      } else {
        setTransportForm(EMPTY_TRANSPORT);
        setServiceMonth([]);
      }
    },
    [getTransportSetupData, sessionStartDate]
  );

  //Created By Cursor
  const handleTransportField = useCallback(
    (key, value) => {
      if (key === "pickupPoint") {
        const id =
          pickupByName.get(String(value || "").trim().toLowerCase()) || "";
        setTransportForm((prev) => ({
          ...prev,
          pickupPoint: value,
          pickupPointId: id,
        }));
        return;
      }
      setTransportForm((prev) => ({ ...prev, [key]: value }));
    },
    [pickupByName]
  );

  //Created By Cursor
  const handleMonthClick = useCallback((month) => {
    setServiceMonth((prev) =>
      prev.includes(month) ? prev.filter((m) => m !== month) : [...prev, month]
    );
  }, []);

  //Created By Cursor
  const toggleAllMonths = useCallback(() => {
    setServiceMonth((prev) =>
      prev.length === sessionMonths.length ? [] : sessionMonths.slice()
    );
  }, [sessionMonths]);

  useEffect(() => {
    return () => {
      if (transportAbortRef.current) transportAbortRef.current.abort();
    };
  }, []);

  //Created By Cursor
  const updateField = useCallback((key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  }, []);

  //Created By Cursor
  const regChange = useCallback(
    (e) => {
      updateField(e.target.id, e.target.value);
    },
    [updateField]
  );

  //Created By Cursor
  const applyFilteredClasses = useCallback(
    (classData, boardId, mediumId, preferredPosition = 0) => {
      const filtered = buildFilteredClassSections(
        classData,
        boardId,
        mediumId
      );
      setClassList(filtered);

      if (filtered.length === 0) {
        setClassSelectedPosition(0);
        setClassId("");
        setSectionId("");
        return;
      }

      const position = Math.min(
        Math.max(preferredPosition, 0),
        filtered.length - 1
      );
      setClassSelectedPosition(position);
      setClassId(filtered[position].class_id || "");
      setSectionId(filtered[position].section_id || "No");
    },
    []
  );

  //Created By Cursor
  const getAdmissionNo = useCallback(async () => {
    const schoolCode = SessionManager.getSchoolCode();
    if (!schoolCode) return;

    try {
      const response = await axios.get(`${API_BASE()}getLastAdmissionNo.php`, {
        params: { school_code: schoolCode },
      });

      if (response.data?.api_status === "OK") {
        const rows = response.data.data || [];
        const nextNo =
          rows.length > 0
            ? nextAdmissionNo(rows[0].sr_admission_no)
            : "1";
        updateField("AddmissionNumber", String(nextNo));
      }
    } catch (error) {
      console.error("Error fetching admission number:", error);
    }
  }, [updateField]);

  //Created By Cursor
  const getClass = useCallback(
    async ({ soft = false } = {}) => {
      if (!SESSION_ID) {
        setMClassData([]);
        setClassBoard([]);
        setClassMedium([]);
        setClassList([]);
        if (!soft) setBootLoading(false);
        return;
      }

      const schoolCode = SessionManager.getSchoolCode();
      if (!schoolCode) {
        myToast.notify_warning("School code is missing.");
        if (!soft) setBootLoading(false);
        return;
      }

      if (!soft) setBootLoading(true);

      try {
        const response = await axios.get(`${API_BASE()}getClass.php`, {
          params: {
            school_code: schoolCode,
            session_id: SESSION_ID,
          },
        });

        if (response.data?.api_status === "OK") {
          const boards = response.data.data?.board || [];
          const mediums = response.data.data?.medium || [];
          const classes = response.data.data?.class || [];

          setClassBoard(boards);
          setClassMedium(mediums);
          setMClassData(classes);

          setFormData((prev) => {
            const boardStillValid = boards.some(
              (b) => String(b.board_id) === String(prev.board_id)
            );
            const mediumStillValid = mediums.some(
              (m) => String(m.medium_id) === String(prev.medium_id)
            );
            return {
              ...prev,
              board_id: boardStillValid
                ? String(prev.board_id)
                : boards.length > 0
                  ? String(boards[0].board_id)
                  : "",
              medium_id: mediumStillValid
                ? String(prev.medium_id)
                : mediums.length > 0
                  ? String(mediums[0].medium_id)
                  : "",
            };
          });
        } else {
          setMClassData([]);
          setClassBoard([]);
          setClassMedium([]);
          setClassList([]);
          myToast.notify_warning(
            response.data?.api_remark || "Could not load classes."
          );
        }
      } catch (error) {
        console.error("Error fetching classes:", error);
        myToast.notify_warning("Network error loading classes.");
      } finally {
        if (!soft) setBootLoading(false);
      }
    },
    [SESSION_ID, applyFilteredClasses]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    let cancelled = false;

    (async () => {
      setBootLoading(true);
      await Promise.all([getAdmissionNo(), getClass({ soft: true })]);
      if (!cancelled) setBootLoading(false);
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SESSION_ID]);

  useEffect(() => {
    applyFilteredClasses(
      mClassData,
      formData.board_id,
      formData.medium_id,
      0
    );
  }, [
    formData.board_id,
    formData.medium_id,
    mClassData,
    applyFilteredClasses,
  ]);

  //Created By Cursor
  const selectClass = useCallback(
    (position) => {
      if (!classList[position]) return;
      setClassSelectedPosition(position);
      setClassId(classList[position].class_id || "");
      setSectionId(classList[position].section_id || "No");
    },
    [classList]
  );

  //Created By Cursor
  const handleSameAsCurrent = useCallback((checked) => {
    setSameAsCurrent(checked);
    if (!checked) return;
    setFormData((prev) => ({
      ...prev,
      perAddress: prev.curAddress,
    }));
  }, []);

  useEffect(() => {
    if (!sameAsCurrent) return;
    setFormData((prev) => ({
      ...prev,
      perAddress: prev.curAddress,
    }));
  }, [sameAsCurrent, formData.curAddress]);

  //Created By Cursor
  const isValidInput = useCallback(() => {
    if (!formData.AddmisType) {
      myToast.notify_warning("Please select admission type.");
      return false;
    }
    if (!formData.FirstName?.trim()) {
      myToast.notify_warning("First name is required.");
      return false;
    }
    if (!formData.date) {
      myToast.notify_warning("Admission date is required.");
      return false;
    }
    if (!formData.dob) {
      myToast.notify_warning("Date of birth is required.");
      return false;
    }
    if (!formData.gender) {
      myToast.notify_warning("Please select gender.");
      return false;
    }
    if (!formData.community) {
      myToast.notify_warning("Please select community.");
      return false;
    }
    if (!formData.nationality?.trim()) {
      myToast.notify_warning("Nationality is required.");
      return false;
    }
    if (!formData.RELIGION || formData.RELIGION === "Select Religion") {
      myToast.notify_warning("Religion is required.");
      return false;
    }
    if (!formData.board_id) {
      myToast.notify_warning("Please select board.");
      return false;
    }
    if (!formData.medium_id) {
      myToast.notify_warning("Please select medium.");
      return false;
    }
    if (!CLASS_ID) {
      myToast.notify_warning("Please select a class.");
      return false;
    }
    if (!formData.curAddress?.trim()) {
      myToast.notify_warning("Current address is required.");
      return false;
    }
    if (!formData.perAddress?.trim()) {
      myToast.notify_warning("Permanent address is required.");
      return false;
    }
    if (!formData.FatherName?.trim()) {
      myToast.notify_warning("Father name is required.");
      return false;
    }
    if (!formData.fatherOccupation?.trim()) {
      myToast.notify_warning("Father occupation is required.");
      return false;
    }
    if (!formData.motherName?.trim()) {
      myToast.notify_warning("Mother name is required.");
      return false;
    }
    if (!formData.motherOccupation?.trim()) {
      myToast.notify_warning("Mother occupation is required.");
      return false;
    }
    if (transportGranted === "Yes") {
      if (!transportForm.routeId) {
        myToast.notify_warning("Select a transport route.");
      return false;
    }
      if (!transportForm.vehicleId) {
        myToast.notify_warning("Select a transport vehicle.");
      return false;
    }
      if (!String(transportForm.pickupPoint || "").trim()) {
        myToast.notify_warning("Enter pickup point.");
      return false;
    }
      if (!pickupTime) {
        myToast.notify_warning("Select pickup time.");
      return false;
    }
      if (!String(transportForm.transportFee || "").trim()) {
        myToast.notify_warning("Enter transport fee.");
      return false;
    }
      if (!serviceMonth.length) {
        myToast.notify_warning("Select at least one service month.");
      return false;
    }
    }
      return true;
  }, [formData, CLASS_ID, transportGranted, transportForm, pickupTime, serviceMonth.length]);

  //Created By Cursor
  const assignTransportAfterRegister = useCallback(
    async (studentId) => {
      const schoolCode = SessionManager.getSchoolCode();
      const staffId = SessionManager.getStaffDetails()?.staff_id;
      const resolvedPickupPointId =
        transportForm.pickupPointId ||
        pickupByName.get(
          String(transportForm.pickupPoint || "").trim().toLowerCase()
        ) ||
        "";

      const params = new URLSearchParams({
        staff_id: staffId || "",
        student_id: studentId,
        session_id: SESSION_ID,
        class_id: CLASS_ID,
        section_id: SECTION_ID || "",
        vehicle_id: transportForm.vehicleId,
        route_id: transportForm.routeId,
        pickup_point_id: resolvedPickupPointId,
        pickup_point_name: transportForm.pickupPoint,
        pickup_time: pickupTime,
        transport_fee: transportForm.transportFee,
        concession_granted: "No",
        applicable_month: reverseApplicableMonths(serviceMonth),
        service_id: TRANSPORT_SERVICE_ID,
        school_code: schoolCode,
      });

      const response = await axios.post(
        `${API_BASE()}addTransportStudent.php`,
        params,
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      );

      if (response.data?.api_status !== "OK") {
        throw new Error(
          response.data?.api_remark || "Failed to assign transport."
        );
      }
    },
    [
      transportForm,
      pickupByName,
      pickupTime,
      serviceMonth,
      SESSION_ID,
      CLASS_ID,
      SECTION_ID,
    ]
  );

  //Created By Cursor
  const regSubmit = useCallback(async () => {
    if (!isValidInput()) return;

    setSubmitting(true);
    const schoolCode = SessionManager.getSchoolCode();
    const staffId = SessionManager.getStaffDetails()?.staff_id;

    const params = new URLSearchParams();
    params.append("school_code", schoolCode);
    params.append("session_id", SESSION_ID);
    params.append(
      "student_name",
      `${formData.FirstName.trim()} ${formData.LastName.trim()}`.trim()
    );
    params.append("dob", formData.dob);
    params.append("admDate", formData.date);
    params.append("admission_type", formData.AddmisType);
    params.append("admission_no", formData.AddmissionNumber);
    params.append("state_specific_id_name", formData.StateSpecificIdName);
    params.append("state_specific_id_value", formData.StateSpecificIdValue);
    params.append("previous_school_name", formData.previous_school_name);
    params.append("previous_class", formData.previous_class);
    params.append("academic_mode", "ACDM01");
    params.append("religion", formData.RELIGION);
    params.append("gender", formData.gender);
    params.append("community", formData.community);
    params.append("caste", formData.caste);
    params.append("aadhar_no", formData.AdharNo);
    params.append("nationality", formData.nationality);
    params.append("bloodgroup", formData.bloodgroup);
    params.append("mother_tongue", formData.mother_tongue);
    params.append("birth_place", formData.birth_place);
    params.append("height", formData.height || "0");
    params.append("weight", formData.weight || "0");
    params.append("student_pen", formData.student_pen);
    params.append("student_apaar", formData.student_apaar);
    params.append("bpl_beneficiary", formData.bpl_beneficiary || "No");
    params.append("physical_disability", formData.physical_disability || "No");
    params.append("board_id", formData.board_id);
    params.append("medium_id", formData.medium_id);
    params.append("class_id", CLASS_ID);
    params.append("section_id", SECTION_ID);
    params.append("village_town", formData.curAddress.trim());
    params.append("post_locality", "");
    params.append("police_station", "");
    params.append("curAddress", formData.curAddress.trim());
    params.append("perAddress", formData.perAddress.trim());
    params.append("father_name", formData.FatherName);
    params.append("father_occupation", formData.fatherOccupation);
    params.append("father_qualification", formData.father_qualification);
    params.append("father_aadhar", formData.father_aadhar);
    params.append("mother_name", formData.motherName);
    params.append("mother_occupation", formData.motherOccupation);
    params.append("mother_qualification", formData.mother_qualification);
    params.append("mother_aadhar", formData.mother_aadhar);
    params.append("contact1", formData.contact1);
    params.append("contact_person_name1", formData.contactName_1);
    params.append("contact_person1", formData.relation_1);
    params.append("contact2", formData.contact2);
    params.append("contact_person_name2", formData.contactName_2);
    params.append("contact_person2", formData.relation_2);
    params.append("email", formData.email);
    params.append("caste", formData.caste);
    params.append("staff_id", staffId);

    try {
      const response = await axios.post(
        `${API_BASE()}registerStudentWeb.php`,
        params
      );

      if (response.data?.api_status === "OK") {
        const enrollmentNo = response.data.data;
        if (transportGranted === "Yes") {
          try {
            await assignTransportAfterRegister(enrollmentNo);
            myToast.notify_success(
              "Student registered and transport assigned."
            );
          } catch (transportError) {
            console.error(transportError);
            myToast.notify_warning(
              transportError?.message ||
                "Student registered, but transport assignment failed."
            );
          }
        } else {
          myToast.notify_success("Student registered successfully.");
        }
        window.location.href = `/AdminMain/StudentRegSuccess/${enrollmentNo}/${SESSION_ID}`;
      } else {
        myToast.notify_warning(
          response.data?.api_remark || "Problem in registration."
        );
      }
    } catch (error) {
      console.error("Error registering student:", error);
      myToast.notify_error("Network error during registration.");
    } finally {
      setSubmitting(false);
    }
  }, [
    isValidInput,
    SESSION_ID,
    formData,
    CLASS_ID,
    SECTION_ID,
    transportGranted,
    assignTransportAfterRegister,
  ]);

  //Created By Cursor
  const handleSelectedSession = useCallback(
    (sessionId, sessionName, sessionStatus, startDate) => {
      setSessionId(sessionId);
      setSessionName(sessionName);
      setSessionStatus(sessionStatus);
      if (startDate) setSessionStartDate(startDate);
      setSessionMonths(buildSessionMonths(startDate));
      setServiceMonth([]);
      setIsOpenSessionDialog(false);
    },
    []
  );

  //Created By Cursor
  const handlePhotoChange = useCallback((e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      myToast.notify_warning("Please select an image file.");
      return;
    }
    setPhotoPreview((prev) => {
      if (prev) URL.revokeObjectURL(prev);
      return URL.createObjectURL(file);
    });
  }, []);

  //Created By Cursor
  const clearPhoto = useCallback(() => {
    setPhotoPreview((prev) => {
      if (prev) URL.revokeObjectURL(prev);
      return null;
    });
    if (photoInputRef.current) photoInputRef.current.value = "";
  }, []);

  if (!loggedIn) return <Redirect to="/Login" />;
  if (bootLoading) return <MyLoader />;

  return (
    <div
      className="content payroll-page sm-page sr-page stur-page"
      style={{ background: COLORS.white, fontFamily: PAGE_FONT }}
    >
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <span style={{ color: COLORS.white }}> Student Registration</span>
            </li>
          </ul>
                                    </div>
        <div className="rightside-content-header">
          <BackButton />
                                    </div>
                                  </div>

      <div className="bg_page_white_rounded box_shadow animated fadeInUp sm-shell">
        <header className="sm-hero" style={{ "--sm-hero-bg": HERO_GRADIENT }}>
          <div className="sm-hero__brand">
            <div className="sm-hero__icon" aria-hidden>
              <FaUserGraduate />
                                        </div>
            <div className="min-w-0">
              <h1 className="sm-hero__title">Register New Student</h1>
              <p className="sm-hero__sub">
                Create an admission profile for the selected session
              </p>
                                          </div>
                                        </div>
          <div className="sm-hero__tools">
            <button
              type="button"
              className="stur-hero-session"
              onClick={() => setIsOpenSessionDialog(true)}
              title="Change academic session"
            >
              <FaCalendarAlt aria-hidden />
              <span className="stur-hero-session__text min-w-0">
                <span className="stur-hero-session__label">Session</span>
                <strong className="stur-hero-session__name">
                  {SESSION_NAME || "Select session"}
                  {SESSION_STATUS ? ` · ${SESSION_STATUS}` : ""}
                </strong>
              </span>
              <FaExchangeAlt className="stur-hero-session__swap" aria-hidden />
            </button>
                                      </div>
        </header>

        <div className="sr-body stur-body">
          <div className="stur-photo-wrap">
            <button
              type="button"
              className={`stur-photo ${photoPreview ? "stur-photo--has" : ""}`}
              onClick={() => photoInputRef.current?.click()}
              aria-label="Upload student photo"
            >
              {photoPreview ? (
                <img
                  src={photoPreview}
                  alt="Student"
                  className="stur-photo__img"
                />
              ) : (
                <span className="stur-photo__empty">
                  <FaCamera className="stur-photo__icon" aria-hidden />
                  <span className="stur-photo__title">Student photo</span>
                  <span className="stur-photo__hint">Click to upload</span>
                </span>
              )}
            </button>
            <input
              ref={photoInputRef}
              type="file"
              accept="image/*"
              hidden
              onChange={handlePhotoChange}
            />
            {photoPreview ? (
              <div className="stur-photo__actions">
                <button
                  type="button"
                  className="stur-photo__btn"
                  onClick={() => photoInputRef.current?.click()}
                >
                  Change
                </button>
                <button
                  type="button"
                  className="stur-photo__btn stur-photo__btn--ghost"
                  onClick={clearPhoto}
                >
                  Remove
                </button>
                                        </div>
            ) : null}
                                          </div>

          <SectionCard
            icon={FaSchool}
            step="01"
            title="Class Information"
            subtitle="Board, medium, and participating class"
          >
            <div className="stur-basic">
              <div className="stur-basic__group stur-basic__group--class">
                <div className="stur-basic__grid stur-basic__grid--3">
                  <Field label="Board" required>
                    <Form.Select
                      className="sr-input sr-select"
                      value={formData.board_id}
                      onChange={(e) => updateField("board_id", e.target.value)}
                    >
                      <option value="">Select board</option>
                      {classBoard.map((item, index) => (
                        <option
                          key={item.board_id || index}
                          value={item.board_id}
                        >
                          {item.board_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Field>
                  <Field label="Medium" required>
                    <Form.Select
                      className="sr-input sr-select"
                      value={formData.medium_id}
                      onChange={(e) =>
                        updateField("medium_id", e.target.value)
                      }
                    >
                      <option value="">Select medium</option>
                      {classMedium.map((item, index) => (
                        <option
                          key={item.medium_id || index}
                          value={item.medium_id}
                        >
                          {item.medium_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Field>
                  <Field label="Class" required>
                    <Form.Select
                      className="sr-input sr-select"
                      value={
                        classList.length > 0
                          ? String(classSelectedPosition)
                          : ""
                      }
                      onChange={(e) => selectClass(Number(e.target.value))}
                      disabled={!classList.length}
                    >
                      <option value="">
                        {classList.length
                          ? "Select class"
                          : "No classes found"}
                      </option>
                      {classList.map((item, index) => (
                        <option
                          key={`${item.class_id}-${item.section_id}-${index}`}
                          value={index}
                        >
                          {classChipLabel(item)}
                        </option>
                      ))}
                    </Form.Select>
                  </Field>
                                        </div>
                                      </div>
                                    </div>
          </SectionCard>

          <SectionCard
            icon={FaIdCard}
            step="02"
            title="Admission Details"
            subtitle="Type, number, and previous school information"
          >
            <div className="stur-basic">
              <div className="stur-basic__group stur-basic__group--adm-type">
                <div className="stur-basic__grid stur-basic__grid--adm-type">
                  <Field label="Admission Type" required>
                    <div
                      className="sr-chip-row stur-adm-chips"
                      role="group"
                      aria-label="Admission type"
                    >
                      {ADMISSION_TYPES.map((type) => (
                        <button
                          key={type.value}
                          type="button"
                          className={`sr-choice-chip${
                            formData.AddmisType === type.value
                              ? " is-active"
                              : ""
                          }`}
                          onClick={() =>
                            updateField("AddmisType", type.value)
                          }
                        >
                          {type.label}
                        </button>
                      ))}
                                        </div>
                  </Field>
                  <Field label="Admission Number" optional>
                    <input
                      type="text"
                      id="AddmissionNumber"
                      className="sr-input"
                      placeholder="Auto-generated"
                      value={formData.AddmissionNumber}
                      onChange={regChange}
                    />
                  </Field>
                                      </div>
                                    </div>

              <div className="stur-basic__group stur-basic__group--adm-ids">
                <div className="stur-basic__grid stur-basic__grid--4">
                  <Field label="Student PEN" optional>
                    <input
                      type="text"
                      id="student_pen"
                      className="sr-input"
                      placeholder="Enter PEN"
                      value={formData.student_pen}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Student APAAR" optional>
                    <input
                      type="text"
                      id="student_apaar"
                      className="sr-input"
                      placeholder="Enter APAAR ID"
                      value={formData.student_apaar}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="State Specific ID Name" optional>
                    <input
                      type="text"
                      id="StateSpecificIdName"
                      className="sr-input"
                      placeholder="e.g. State ID name"
                      value={formData.StateSpecificIdName}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="State Specific ID Number" optional>
                    <input
                      type="text"
                      id="StateSpecificIdValue"
                      className="sr-input"
                      placeholder="Enter ID number"
                      value={formData.StateSpecificIdValue}
                      onChange={regChange}
                    />
                  </Field>
                                      </div>
                                    </div>

              <div className="stur-basic__group stur-basic__group--adm-prev">
                <div className="stur-basic__grid stur-basic__grid--2">
                  <Field label="Previous School Name" optional>
                    <input
                      type="text"
                      id="previous_school_name"
                      className="sr-input"
                      placeholder="Previous school name"
                      value={formData.previous_school_name}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Previous Class" optional>
                    <input
                      type="text"
                      id="previous_class"
                      className="sr-input"
                      placeholder="e.g. Class 5"
                      value={formData.previous_class}
                      onChange={regChange}
                    />
                  </Field>
                                          </div>
                                        </div>
                                      </div>
          </SectionCard>

          <SectionCard
            icon={FaUserGraduate}
            step="03"
            title="Basic Information"
            subtitle="Personal details of the student"
          >
            <div className="stur-basic">
              <div className="stur-basic__group stur-basic__group--identity">
                <div className="stur-basic__group-head">
                  <span className="stur-basic__group-title">Identity</span>
                  <span className="stur-basic__group-line" aria-hidden />
                                        </div>
                <div className="stur-basic__grid stur-basic__grid--4">
                  <Field label="First Name" required>
                    <input
                      type="text"
                      id="FirstName"
                      className="sr-input"
                      placeholder="First name"
                      value={formData.FirstName}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Last Name" optional>
                    <input
                      type="text"
                      id="LastName"
                      className="sr-input"
                      placeholder="Last name"
                      value={formData.LastName}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Admission Date" required>
                    <input
                      type="date"
                      id="date"
                      className="sr-input"
                      value={formData.date}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Date of Birth" required>
                    <input
                      type="date"
                      id="dob"
                      className="sr-input"
                      value={formData.dob}
                      onChange={regChange}
                    />
                  </Field>
                                      </div>
                                    </div>

              <div className="stur-basic__group stur-basic__group--demographics">
                <div className="stur-basic__group-head">
                  <span className="stur-basic__group-title">Demographics</span>
                  <span className="stur-basic__group-line" aria-hidden />
                                        </div>
                <div className="stur-basic__grid stur-basic__grid--6">
                  <Field label="Gender" required>
                    <Form.Select
                      className="sr-input sr-select"
                      value={formData.gender}
                      onChange={(e) => updateField("gender", e.target.value)}
                    >
                      <option value="">Select</option>
                      {GENDERS.map((g) => (
                        <option key={g} value={g}>
                          {g}
                        </option>
                      ))}
                                           </Form.Select>
                  </Field>
                  <Field label="Community" required>
                    <Form.Select
                      className="sr-input sr-select"
                      value={formData.community}
                      onChange={(e) => updateField("community", e.target.value)}
                    >
                      <option value="">Select</option>
                      {COMMUNITIES.map((c) => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                    </Form.Select>
                  </Field>
                  <Field label="Religion" required>
                    <Form.Select
                      className="sr-input sr-select"
                      value={formData.RELIGION}
                      onChange={(e) => updateField("RELIGION", e.target.value)}
                    >
                      <option value="">Select</option>
                      {RELIGIONS.map((r) => (
                        <option key={r} value={r}>
                          {r}
                        </option>
                      ))}
                    </Form.Select>
                  </Field>
                  <Field label="Caste" optional>
                    <input
                      type="text"
                      id="caste"
                      className="sr-input"
                      placeholder="Caste"
                      value={formData.caste}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Nationality" required>
                    <input
                      type="text"
                      id="nationality"
                      className="sr-input"
                      placeholder="Nationality"
                      value={formData.nationality}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Aadhaar" optional>
                    <input
                      type="text"
                      id="AdharNo"
                      className="sr-input"
                      placeholder="Aadhaar number"
                      value={formData.AdharNo}
                      onChange={regChange}
                    />
                  </Field>
                    </div>
                  </div>
  
              <div className="stur-basic__group stur-basic__group--physical">
                <div className="stur-basic__group-head">
                  <span className="stur-basic__group-title">
                    Physical &amp; other
                  </span>
                  <span className="stur-basic__group-line" aria-hidden />
                 </div> 
                <div className="stur-basic__grid stur-basic__grid--4">
                  <Field label="Blood Group" optional>
                    <Form.Select
                      className="sr-input sr-select"
                      value={formData.bloodgroup}
                      onChange={(e) =>
                        updateField("bloodgroup", e.target.value)
                      }
                    >
                      <option value="">Select</option>
                      {BLOOD_GROUPS.map((bg) => (
                        <option key={bg} value={bg}>
                          {bg}
                        </option>
                      ))}
                    </Form.Select>
                  </Field>
                  <Field label="Mother Tongue" optional>
                    <Form.Select
                      className="sr-input sr-select"
                      value={formData.mother_tongue}
                      onChange={(e) =>
                        updateField("mother_tongue", e.target.value)
                      }
                    >
                      <option value="">Select</option>
                      {MOTHER_TONGUE_OPTIONS.map((tongue) => (
                        <option key={tongue} value={tongue}>
                          {tongue}
                        </option>
                      ))}
                    </Form.Select>
                  </Field>
                  <Field label="Birth Place" optional>
                    <input
                      type="text"
                      id="birth_place"
                      className="sr-input"
                      placeholder="Place of birth"
                      value={formData.birth_place}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Height (cm)" optional>
                    <input
                      type="text"
                      id="height"
                      className="sr-input"
                      placeholder="e.g. 140"
                      value={formData.height}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Weight (kg)" optional>
                    <input
                      type="text"
                      id="weight"
                      className="sr-input"
                      placeholder="e.g. 35"
                      value={formData.weight}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="BPL Beneficiary" optional>
                    <Form.Select
                      className="sr-input sr-select"
                      value={formData.bpl_beneficiary}
                      onChange={(e) =>
                        updateField("bpl_beneficiary", e.target.value)
                      }
                    >
                      {YES_NO.map((v) => (
                        <option key={v} value={v}>
                          {v}
                        </option>
                      ))}
                    </Form.Select>
                  </Field>
                  <Field label="Physical Disability" optional>
                    <Form.Select
                      className="sr-input sr-select"
                      value={formData.physical_disability}
                      onChange={(e) =>
                        updateField("physical_disability", e.target.value)
                      }
                    >
                      {YES_NO.map((v) => (
                        <option key={v} value={v}>
                          {v}
                        </option>
                      ))}
                    </Form.Select>
                  </Field>
                      </div>
            </div>
                                  </div>
          </SectionCard>

          <SectionCard
            icon={FaMapMarkerAlt}
            step="04"
            title="Address"
            subtitle="Current and permanent residential address"
            extra={
              <label className="stur-same-toggle">
                <input
                  type="checkbox"
                  checked={sameAsCurrent}
                  onChange={(e) => handleSameAsCurrent(e.target.checked)}
                />
                Same as current
              </label>
            }
          >
            <div className="stur-basic stur-address-panels">
              <div className="stur-basic__group stur-basic__group--addr-current">
                <div className="stur-basic__group-head">
                  <span className="stur-basic__group-title">Current</span>
                  <span className="stur-basic__group-line" aria-hidden />
                                      </div>
                <Field label="Full address" required>
                  <textarea
                    id="curAddress"
                    rows={2}
                    className="sr-input sr-textarea"
                    placeholder="House / street, locality, city, PIN"
                    value={formData.curAddress}
                    onChange={regChange}
                  />
                </Field>
                                    </div>
              <div className="stur-basic__group stur-basic__group--addr-permanent">
                <div className="stur-basic__group-head">
                  <span className="stur-basic__group-title">Permanent</span>
                  <span className="stur-basic__group-line" aria-hidden />
                                        </div>
                <Field label="Full address" required>
                  <textarea
                    id="perAddress"
                    rows={2}
                    className="sr-input sr-textarea"
                    placeholder="House / street, locality, city, PIN"
                    value={formData.perAddress}
                    onChange={regChange}
                    disabled={sameAsCurrent}
                  />
                </Field>
                                          </div>
                                        </div>
          </SectionCard>

          <SectionCard
            icon={FaUserFriends}
            step="05"
            title="Family Information"
            subtitle="Parent or guardian details"
          >
            <div className="stur-basic">
              <div className="stur-basic__group stur-basic__group--family-father">
                <div className="stur-basic__group-head">
                  <span className="stur-basic__group-title">Father</span>
                  <span className="stur-basic__group-line" aria-hidden />
                                        </div>
                <div className="stur-basic__grid stur-basic__grid--4">
                  <Field label="Name" required>
                    <input
                      type="text"
                      id="FatherName"
                      className="sr-input"
                      placeholder="Father name"
                      value={formData.FatherName}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Occupation" required>
                    <input
                      type="text"
                      id="fatherOccupation"
                      className="sr-input"
                      placeholder="Occupation"
                      value={formData.fatherOccupation}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Qualification" optional>
                    <input
                      type="text"
                      id="father_qualification"
                      className="sr-input"
                      placeholder="e.g. Graduate"
                      value={formData.father_qualification}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Aadhaar" optional>
                    <input
                      type="text"
                      id="father_aadhar"
                      className="sr-input"
                      placeholder="Aadhaar number"
                      value={formData.father_aadhar}
                      onChange={regChange}
                    />
                  </Field>
                                          </div>
                                        </div>
              <div className="stur-basic__group stur-basic__group--family-mother">
                <div className="stur-basic__group-head">
                  <span className="stur-basic__group-title">Mother</span>
                  <span className="stur-basic__group-line" aria-hidden />
                                      </div>
                <div className="stur-basic__grid stur-basic__grid--4">
                  <Field label="Name" required>
                    <input
                      type="text"
                      id="motherName"
                      className="sr-input"
                      placeholder="Mother name"
                      value={formData.motherName}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Occupation" required>
                    <input
                      type="text"
                      id="motherOccupation"
                      className="sr-input"
                      placeholder="Occupation"
                      value={formData.motherOccupation}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Qualification" optional>
                    <input
                      type="text"
                      id="mother_qualification"
                      className="sr-input"
                      placeholder="e.g. Graduate"
                      value={formData.mother_qualification}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Aadhaar" optional>
                    <input
                      type="text"
                      id="mother_aadhar"
                      className="sr-input"
                      placeholder="Aadhaar number"
                      value={formData.mother_aadhar}
                      onChange={regChange}
                    />
                  </Field>
                                    </div>
                                        </div>
                                          </div>
          </SectionCard>

          <SectionCard
            icon={FaPhoneAlt}
            step="06"
            title="Contact Details"
            subtitle="Primary and alternate contact persons"
          >
            <div className="stur-basic">
              <div className="stur-basic__group stur-basic__group--contact-1">
                <div className="stur-basic__group-head">
                  <span className="stur-basic__group-title">Contact 1</span>
                  <span className="stur-basic__group-line" aria-hidden />
                                        </div>
                <div className="stur-basic__grid stur-basic__grid--3">
                  <Field label="Mobile" optional>
                    <input
                      type="tel"
                      id="contact1"
                      className="sr-input"
                      placeholder="Mobile number"
                      value={formData.contact1}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Person name" optional>
                    <input
                      type="text"
                      id="contactName_1"
                      className="sr-input"
                      placeholder="Person name"
                      value={formData.contactName_1}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Relation" optional>
                    <Form.Select
                      className="sr-input sr-select"
                      value={formData.relation_1}
                      onChange={(e) =>
                        updateField("relation_1", e.target.value)
                      }
                    >
                      <option value="">Select relation</option>
                      {RELATIONS.map((r) => (
                        <option key={r} value={r}>
                          {r}
                        </option>
                      ))}
                                           </Form.Select>
                  </Field>
                                          </div>
                                        </div>
              <div className="stur-basic__group stur-basic__group--contact-2">
                <div className="stur-basic__group-head">
                  <span className="stur-basic__group-title">Contact 2</span>
                  <span className="stur-basic__group-line" aria-hidden />
                                      </div>
                <div className="stur-basic__grid stur-basic__grid--3">
                  <Field label="Mobile" optional>
                    <input
                      type="tel"
                      id="contact2"
                      className="sr-input"
                      placeholder="Mobile number"
                      value={formData.contact2}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Person name" optional>
                    <input
                      type="text"
                      id="contactName_2"
                      className="sr-input"
                      placeholder="Person name"
                      value={formData.contactName_2}
                      onChange={regChange}
                    />
                  </Field>
                  <Field label="Relation" optional>
                    <Form.Select
                      className="sr-input sr-select"
                      value={formData.relation_2}
                      onChange={(e) =>
                        updateField("relation_2", e.target.value)
                      }
                    >
                      <option value="">Select relation</option>
                      {RELATIONS.map((r) => (
                        <option key={r} value={r}>
                          {r}
                        </option>
                      ))}
                                   </Form.Select>
                  </Field>
                                        </div>
                                      </div>
              <div className="stur-basic__group stur-basic__group--contact-email">
                <div className="stur-basic__grid stur-basic__grid--email">
                  <Field label="Email" optional>
                    <input
                      type="email"
                      id="email"
                      className="sr-input"
                      placeholder="student@example.com"
                      value={formData.email}
                      onChange={regChange}
                    />
                  </Field>
                                    </div>
                                  </div>
                                      </div>
          </SectionCard>

          <SectionCard
            icon={FaBus}
            step="07"
            title="Transport"
            subtitle="Grant transport and assign route details"
          >
            <div className="stur-basic">
              <div className="stur-basic__group stur-basic__group--transport-grant">
                <Field label="Transport Granted" required>
                  <div
                    className="sr-chip-row stur-adm-chips"
                    role="group"
                    aria-label="Transport granted"
                  >
                    {YES_NO.map((value) => (
                      <button
                        key={value}
                        type="button"
                        className={`sr-choice-chip${
                          transportGranted === value ? " is-active" : ""
                        }`}
                        onClick={() => handleTransportGranted(value)}
                      >
                        {value}
                      </button>
                    ))}
                                      </div>
                </Field>
                                    </div>

              {transportGranted === "Yes" ? (
                transportLoading ? (
                  <div className="stur-transport-loading">
                    Loading transport setup…
                                          </div>
                ) : (
                  <>
                    <div className="stur-basic__group stur-basic__group--transport-details">
                      <div className="stur-basic__group-head">
                        <span className="stur-basic__group-title">
                          Assignment
                        </span>
                        <span className="stur-basic__group-line" aria-hidden />
                                            </div>
                      <div className="stur-basic__grid stur-basic__grid--3">
                        <Field label="Route" required>
                          <Form.Select
                            className="sr-input sr-select"
                            value={transportForm.routeId}
                            onChange={(e) =>
                              handleTransportField("routeId", e.target.value)
                            }
                          >
                            <option value="">Select route</option>
                            {routesList.map((item) => (
                              <option
                                key={item.route_id}
                                value={item.route_id}
                              >
                                {item.route_name}
                              </option>
                            ))}
                                          </Form.Select>
                        </Field>
                        <Field label="Vehicle" required>
                          <Form.Select
                            className="sr-input sr-select"
                            value={transportForm.vehicleId}
                            onChange={(e) =>
                              handleTransportField("vehicleId", e.target.value)
                            }
                          >
                            <option value="">Select vehicle</option>
                            {vehicleList.map((item) => (
                              <option
                                key={item.vehicle_id}
                                value={item.vehicle_id}
                              >
                                {item.vehicle_name || item.vehicle_number} (
                                {item.vehicle_type || "—"})
                              </option>
                            ))}
                          </Form.Select>
                        </Field>
                        <Field label="Pickup point" required>
                          <input
                            type="text"
                            className="sr-input"
                            list="stur-pickup-list"
                            value={transportForm.pickupPoint}
                            onChange={(e) =>
                              handleTransportField(
                                "pickupPoint",
                                e.target.value
                              )
                            }
                            placeholder="Type or select pickup point"
                            autoComplete="off"
                          />
                          <datalist id="stur-pickup-list">
                            {pickupPoints.map((point) => (
                              <option
                                key={point.pickup_point_id}
                                value={point.pickup_point_name}
                              />
                            ))}
                          </datalist>
                        </Field>
                                        </div>
                      <div className="stur-basic__grid stur-basic__grid--2 stur-transport-row">
                        <Field label="Pickup time" required>
                          <div
                            className="stur-time-12"
                            role="group"
                            aria-label="Pickup time"
                          >
                            <Form.Select
                              className="sr-input sr-select"
                              value={transportForm.pickupHour}
                              onChange={(e) =>
                                handleTransportField(
                                  "pickupHour",
                                  e.target.value
                                )
                              }
                              aria-label="Hour"
                            >
                              <option value="">Hour</option>
                              {HOURS_12.map((h) => (
                                <option key={h} value={h}>
                                  {h}
                                </option>
                              ))}
                            </Form.Select>
                            <span className="stur-time-12__sep" aria-hidden>
                              :
                            </span>
                            <Form.Select
                              className="sr-input sr-select"
                              value={transportForm.pickupMinute}
                              onChange={(e) =>
                                handleTransportField(
                                  "pickupMinute",
                                  e.target.value
                                )
                              }
                              aria-label="Minute"
                            >
                              <option value="">Min</option>
                              {MINUTES_60.map((m) => (
                                <option key={m} value={m}>
                                  {m}
                                </option>
                              ))}
                            </Form.Select>
                            <Form.Select
                              className="sr-input sr-select"
                              value={transportForm.pickupAmPm}
                              onChange={(e) =>
                                handleTransportField(
                                  "pickupAmPm",
                                  e.target.value
                                )
                              }
                              aria-label="AM or PM"
                            >
                              <option value="AM">AM</option>
                              <option value="PM">PM</option>
                                          </Form.Select>
                                        </div>
                        </Field>
                        <Field label="Transport fee" required>
                          <div className="stur-fee-input-wrap">
                            <span className="stur-fee-prefix" aria-hidden>
                              ₹
                            </span>
                            <input
                              type="number"
                              min="0"
                              className="sr-input stur-fee-input"
                              value={transportForm.transportFee}
                              onChange={(e) =>
                                handleTransportField(
                                  "transportFee",
                                  e.target.value
                                )
                              }
                              placeholder="0"
                            />
                                      </div>
                        </Field>
                                        </div>
                                      </div>

                    <div className="stur-basic__group stur-basic__group--transport-months">
                      <div className="stur-months-box__head">
                        <span className="sr-field__label">
                          Service months{" "}
                          <span className="sr-field__req">*</span>
                        </span>
                        {sessionMonths.length > 0 ? (
                          <button
                            type="button"
                            className="stur-months-toggle"
                            onClick={toggleAllMonths}
                          >
                            {allMonthsSelected ? "Clear all" : "Select all"}
                          </button>
                        ) : null}
                                    </div>
                      <div
                        className="stur-months"
                        role="group"
                        aria-label="Service months"
                      >
                        {sessionMonths.map((month) => {
                          const active = selectedMonthSet.has(month);
                          return (
                            <button
                              key={month}
                              type="button"
                              className={`stur-month${
                                active ? " is-active" : ""
                              }`}
                              onClick={() => handleMonthClick(month)}
                            >
                              {active ? <FaCheck aria-hidden /> : null}
                              {month}
                            </button>
                          );
                        })}
                                  </div>
                                </div>
                  </>
                )
              ) : null}
                                </div>
          </SectionCard>

          <div className="sr-actions stur-actions">
            <div className="stur-actions__hint">
              <FaCheckCircle aria-hidden />
              Review all sections before saving the admission
                              </div>
            <div className="stur-actions__btns">
              <Link
                to="/AdminMain/StudentManagement"
                className="sr-btn sr-btn--ghost"
              >
                Cancel
              </Link>
              <button
                type="button"
                className="sr-btn sr-btn--primary"
                onClick={regSubmit}
                disabled={submitting}
              >
                <FaCheckCircle aria-hidden />
                {submitting ? "Saving…" : "Register Student"}
              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      
      {isOpenSessionDialog ? (
        <MdlSelectSession
          action={() => setIsOpenSessionDialog(false)}
          action2={handleSelectedSession}
        />
      ) : null}
                    </div>
  );
};

export default StudentRegistration;
